const localization = {
    cannot_delete_default_language: '{{languageTag}} is set as your default language and can’t be deleted.',
    invalid_translation_structure: 'Invalid data schemas. Please check your input and try again.',
};
export default localization;
